import { models } from '@tfo/common'
import * as React from 'react'
import { useState } from 'react'
import { observer } from 'mobx-react'
import ReportsItemDate from './ReportsItemDate'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import '../ReportsItem.scss'
import ReportsItem from '../ReportsItem'
import { ClientViewStore } from '../../../../../../../stores/ClientViewStore'


export interface ReportsItemStandardProps {
	data: models.IGroupOrder
	reportPackages: models.ReportPackage[]
	showCompanyName: boolean
	store: ClientViewStore
}

const ReportsItemStandard = ({
	data,
	intl,
	reportPackages,
	showCompanyName,
	store
}: ReportsItemStandardProps & WrappedComponentProps) => {
	const [isExpanded, setIsExpanded] = useState<boolean>(false)
	
	return (
		<div
			className={'ReportsItem ReportsItem--standard ReportsItem--active ReportsItem__Group'}
			id={'reportsItem_' + data.id.toString()}
			data-expanded={isExpanded}>
			<div className={'ReportsItem__Inner ReportsItem__Expanded'} onClick={() => setIsExpanded(!isExpanded)}>
					{showCompanyName && (
					<div className={'ReportsItem__Cell'}>{data.orders[0].companyName}</div>
				)}

				<div className={'ReportsItem__Cell'}>
					{reportPackages.find(x => x.id === data.orders[0].servicePackageId)
						?.customName ?? ''}
				</div>
				<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
					{intl.formatMessage({ id: 'client.reports.item.grouporder' })}
				</div>
				<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
					{intl.formatMessage({ id: 'client.reports.item.amount' })}:&nbsp;
					{data.orders.length}
				</div>
				<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}></div>
				<ReportsItemDate
					date={data.orders[0].availableFrom}
					label={intl.formatMessage({ id: 'common.delivery' })}
				/>
				<KeyboardArrowDownIcon className={'ReportsItem__Group__Indicator'}  />
			</div>
			{isExpanded &&
				<div className='ReportsItem ReportsItem__Group--expanded'>
					{data.orders
						.map((o, index) => <ReportsItem
							data={o}
							key={'reportsItem_' + o.id + index}
							reportPackages={reportPackages}
							store={store}
							onClick={() => {}}
						/>)}
				</div>}
		</div>
	)
}
export default injectIntl(observer(ReportsItemStandard))
